import React from "react";

interface FilterProps {
    id: string;
    placeholder: string;
    onChange: Function;
    value: string;
}

const Filter = (props: FilterProps) => {
    if (props.onChange) {
        return (
            <div className={"textFilter"}>
                <input
                    id={props.id}
                    type={"text"}
                    onChange={(e) => props.onChange(e)}
                    value={props.value}
                    placeholder={props.placeholder}
                />
            </div>
        );
    }

    return null;
};
export default Filter;
